import { render, staticRenderFns } from "./instructions-card.vue?vue&type=template&id=6cd09ba2&scoped=true&"
import script from "./instructions-card.vue?vue&type=script&lang=ts&"
export * from "./instructions-card.vue?vue&type=script&lang=ts&"
import style0 from "./instructions-card.vue?vue&type=style&index=0&id=6cd09ba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd09ba2",
  null
  
)

export default component.exports